import React from "react";
import { createPortal } from "react-dom";

const DynamicMap = ({ zipCode }) => {
  const query = zipCode ? encodeURIComponent(zipCode) : "P25 YW68";
  const mapSrc = `https://www.google.com/maps?q=${query}&output=embed&z=17`;

  return (
    <div className="w-full h-[50vh] bg-gray-200 rounded-lg overflow-hidden mb-2 flex items-center justify-center">
      <iframe
        title="Dynamic Map"
        src={mapSrc}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default function DetailView({ open, zipCode, onClose, locationName }) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-40 z-40"
        onClick={onClose}
      />
      {/* Modal Content */}
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full max-h-[90vh] overflow-auto p-6 relative">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">{locationName}</h2>
            <button
              className="text-gray-600 hover:text-gray-900 text-2xl font-bold"
              onClick={onClose}
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>
          {/* Body */}
          <DynamicMap zipCode={zipCode} />
        </div>
      </div>
    </>,
    document.body
  );
}
